import { get, post, patch, httpDelete, download} from '../axiosReq'

export const login_api = (params,headers) => post("/uc/core/user/login.json",params,headers)
export const logout_api = (params,headers) => post("/uc/core/user/logout.json",params,headers)
export const checkpwd_api = (params,headers) => post("/uc/core/user/isWeakPwd.json",params,headers)
